import React, { useState } from 'react'
import { Link } from 'gatsby';
import { confirmRedirectOnClick, getStyle } from '../helper/utils';

// function useIsMountedRef() {
// 	const isMountedRef = useRef(null);
// 	useEffect(() => {
// 		isMountedRef.current = true;
// 		return () => isMountedRef.current = false;
// 	});
// 	return isMountedRef;
// }

const DropdownLink = ({ anchor, links }) => {

	const [isDDActive, setIsDDActive] = useState(false)
	// const isMountedRef = useIsMountedRef();

	let isActive = ({ isCurrent }) => {
		if (isCurrent) {
			setIsDDActive(true)
			return { className: 'active' }
		}
		else {
			return {}
		}
	}

	const handleDropdownClick = (e) => {
		e.preventDefault();
		const isMobile = getStyle(window.document.getElementById('navTrigger'), 'display') === 'block' ? true : false;
		if (isMobile) {
			const otherDD = window.document.querySelector('.dropdown.active');
			if (otherDD && otherDD !== e.target.closest('.dropdown')) {
				otherDD.classList.remove('active');
			}
			e.target.closest('.dropdown').classList.toggle('active')
		}
		else {
			e.target.closest('.dropdown').classList.remove('active')
		}
	}

	return (
		<li className={`navItem dropdown`}>
			<a href="#!" className={`navLink dropdown-anchor ${isDDActive ? 'active' : ''}`} onClick={handleDropdownClick}>
				<span>{anchor}</span>
			</a>
			<ul className="dropdown-list">
				{links.map((subLink, index) => (
					<li className="dropdown-item" key={index}>
						{subLink.ext ? (
							<a href={subLink.link} onClick={confirmRedirectOnClick}>{subLink.title}</a>
						) : (
								<Link to={subLink.link} getProps={isActive}>{subLink.title}</Link>
							)}
					</li>
				))}
			</ul>
		</li>
	)
}

export default DropdownLink
